module.exports = __webpack_public_path__ + "static/media/hourglass_rainbow_fulla6bc360da633087118d39e98794e06ef.webp";